import type { ReactNode } from 'react';
import { cn } from '../lib/cn';

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('flex flex-col items-center justify-center px-6 py-12 text-center', className)}>
      {icon && (
        <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-ops-lg bg-ops-surface-2 text-ops-text-tertiary">
          {icon}
        </div>
      )}
      <h3 className="text-ops-title font-semibold text-ops-text">{title}</h3>
      {description && <p className="mt-1.5 max-w-sm text-ops-body text-ops-text-tertiary">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
